import React from 'react'
// import { TransitionGroup, CSSTransition } from "react-transition-group";

import project from '../../project'
import Data from './Data'

import { Tracking } from '../../../NodeModules/nnd-track-page'

import { ajaxSetup, getJSON } from 'jquery'
import axios from 'axios';

import "../assets/styles/home.scss"

// const apiURL = 'https://umc4b1dqj0.execute-api.ap-southeast-2.amazonaws.com/default/aa-aws-votes';
const apiURL = 'https://cuv06jxhsh.execute-api.ap-southeast-2.amazonaws.com/default/aa-user-data'
const key = 'aflsalaries-2020';
// const key = 'test';

ajaxSetup({ cache: true })

/* LOAD READER RANKING */
let sortByKey = (array, key, ascdesc) => {
  return array.sort((a, b) => {
    let x = (ascdesc === 'asc') ? b[key] : a[key]
    let y = (ascdesc === 'asc') ? a[key] : b[key]
    return -((x < y) ? -1 : ((x > y) ? 1 : 0))
  })
}


const getToken = () => {
  let userToken = typeof jwt !== 'undefined' ? jwt : ''
  if (userToken === '') {
    userToken = getCookie('rampart_token')
  }
  return userToken
}

// Just a simple cookie reading function to grab the token
const getCookie = (name) => {
  // Note that browser cookies are not available within the native apps
  function escape (s) {
    return s.replace(/([.*+?^${}()|[\]/\\])/g, '\\$1')
  }
  let match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'))
  return match ? match[1] : null
}

class Home extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      view: 'expert',
      firstInteraction: false,
      userToken: getToken(),
      data: undefined //this.loadData2()
    }

    const thisState = this

    this.addBodyEvents()

    let appContainer = document.getElementById(`app_${project.name}`)
    appContainer.addEventListener('mouseenter', (f) => {
      if (!thisState.state.firstInteraction) {
        thisState.state.firstInteraction = true
        Tracking.trackPageImpression('firstinteraction', project.name)
      }
    })
    
  }

  componentDidMount () {
    this.loadData2 ()
  }

  addBodyEvents () {
    setTimeout(() => {
      let navFromTop = document.getElementsByClassName('nnd-navigation')
      let navFromTopBg = document.getElementsByClassName('nnd-navigation-bg')
      let navWidth = navFromTop[0].clientWidth
      let navTopOffset = navFromTop[0].offsetTop
      window.addEventListener('scroll', (e) => {
        this.onScrollEvent(navFromTop, navFromTopBg, navWidth, navTopOffset)
      })
    }, 1000)
  }

  onScrollEvent (navFromTop, navFromTopBg, navWidth, navTopOffset) {
    let nndContainer = document.getElementsByClassName('nnd-container')
    let lastRowContainer = document.getElementsByClassName('nnd-cont-main')[0].firstElementChild
    let totalHeight = nndContainer[0].offsetTop + nndContainer[0].clientHeight - lastRowContainer.clientHeight
    let lastContHeight = nndContainer[0].clientHeight + navFromTop[0].clientHeight - lastRowContainer.clientHeight * 2
    navFromTop[0].style.width = `${navWidth}px`
    navFromTopBg[0].style.height = `${navFromTop[0].clientHeight}px`    
    if (window.scrollY > navTopOffset) {
      // console.log('scrolled over')
      if (window.scrollY > totalHeight) {
        navFromTop[0].setAttribute('name', 'nnd-absolutefromtop')
        navFromTopBg[0].setAttribute('name', 'nnd-normal')
        navFromTop[0].style.top = `${lastContHeight}px`
      } else {
        navFromTop[0].setAttribute('name', 'nnd-fixedtotop')
        navFromTopBg[0].setAttribute('name', 'nnd-fixedtotop')
        navFromTop[0].style.top = `0px`
      }
    } else {
      // console.log('scrolled back')
      navFromTop[0].setAttribute('name', 'nnd-normal')
      navFromTopBg[0].setAttribute('name', 'nnd-normal')
      navFromTop[0].style.top = `0px`
    }
  }

  loadData2 () {
    
    const thisData = Data
    const totalItems = thisData.length
    // const thisState = this

    // console.log('totalItems', totalItems);
    // console.log('key', key);
    // console.log('this.state.userToken', this.state.userToken);

    const postData = {
      'method': 'getAg', // this can be changed to 'get' if you want what the user has selected rather than aggregated
      'key': key,
      'rampart_token': this.state.userToken
    }

    // Do the request
    axios.post(apiURL, postData).then(response => {
      let rData = []
      if (typeof response.data.data.Item !== 'undefined') {
        try {
          rData = JSON.parse(response.data.data.Item.data)
        } catch (e) {
          rData = [response.data.data.Item.data]
        }
      } else  if (typeof response.data.data.Items !== 'undefined' && response.data.data.Items.length > 0) {
        rData = response.data.data.Items[0].data
      }

      // let totalsX = { underated : 0, agreed : 0, overrated : 0 };
      
      for (let i = 0; i < rData.length; i++) {
        let underrated = Number(rData[i]['lower'])
        let agreed = Number(rData[i]['agree'])
        let overrated = Number(rData[i]['higher'])
        // Add weightage to the votes as per expert ranking
        rData[i]['reader_ranking_val'] = ((underrated - overrated) + agreed) + ((totalItems * 5) - ((i + 1) - 1) * 5)

        // totalsX.underated = totalsX.underated + underrated;
        // totalsX.agreed = totalsX.agreed + agreed;
        // totalsX.overrated = totalsX.overrated + overrated;

      }

      // totalsX._TotalVotes = totalsX.underated + totalsX.agreed + totalsX.overrated;
      // console.log('totalsX', totalsX);

      // remove id 55 as wont exist in prod
      // REMOVE BEFORE PRODUCTION
      // data.splice(1, 1);

      // if no votes for an ID, need to add 0 for ranking purposes
      let idsUsed = []
      rData.forEach(item => {
        idsUsed.push(item.id);
      });
      for (let i = 0; i < 100; i++) {
        const isIDThere = idsUsed.indexOf(i+1)
        if (isIDThere == -1) {
          rData.push({id: i + 1, agree: 0, higher: 0, lower: 0, reader_ranking_val: 0});
        }
      }

      // console.log('rData', rData);

      // Sort leader ranking from 1-30 based on votes
      let readerRanking = sortByKey(rData, 'reader_ranking_val', 'desc')
      // console.log('readerRanking:', readerRanking)

      for (let l = 0; l < readerRanking.length; l++) {
        // let thisPos = parseInt(readerRanking[l]['r_id'].replace('r_', ''), 10)
        let thisPos = parseInt(readerRanking[l]['id'], 10)
        let elementPos = thisData.map(function (x) { return x.id }).indexOf(thisPos)

        // console.log('l', l)

        if (elementPos > -1) {
          thisData[elementPos]['peopleid'] = (l + 1)
          thisData[elementPos]['perc']['agree'] = readerRanking[l]['agree']
          thisData[elementPos]['perc']['overrated'] = readerRanking[l]['higher']
          thisData[elementPos]['perc']['underrated'] = readerRanking[l]['lower']

          // agree = on the money, higher = overpaid, lower = underpaid
          let totalVotes = (readerRanking[l]['agree'] + readerRanking[l]['higher'] + readerRanking[l]['lower'])
          let calUnderrated = ( readerRanking[l]['lower'] == 0 ) ? 0 : Math.round((readerRanking[l]['lower'] * 100) / totalVotes)
          let calOverrated = ( readerRanking[l]['higher'] == 0 ) ? 0 : Math.round((readerRanking[l]['higher'] * 100) / totalVotes)
          let calAgree = ( readerRanking[l]['agree'] == 0 ) ? 0 : Math.round((readerRanking[l]['agree'] * 100) / totalVotes)

          // if total not zero and all 3 not equal 100% coz rounding
          if ( (calUnderrated + calOverrated + calUnderrated) !== 100 && totalVotes !== 0 ) {
            calAgree = (100 - calUnderrated - calOverrated)
          }

          // add calculated % to data
          thisData[elementPos]['perc']['agreePC'] = calAgree
          thisData[elementPos]['perc']['overratedPC'] = calOverrated
          thisData[elementPos]['perc']['underratedPC'] = calUnderrated

        }

        if ((readerRanking.length - 1) === l) {
          this.setState({
            data: thisData
          })
        }
      }
    })
    .catch(e => {
      console.error(e.response.status)
        if (e.response.status === 403) {
            console.log('e', e)
        }
    })
  }

  setClassName (e, tabName) {
    if (tabName !== this.state.view) {
      document.getElementsByClassName(`nnd-active-${this.state.view}`)[0].classList.remove(`nnd-active-${this.state.view}`)
      e.target.classList.add(`nnd-active-${tabName}`)
      const grid = document.querySelector('.nnd-cont-main')
      grid.classList.toggle('nnd-hide')
      setTimeout(() => {
        this.state.view = tabName
        grid.setAttribute('name', `nnd-${tabName}`)
        let ratingReaders = grid.querySelectorAll('.nnd-col-rating')
        ratingReaders.forEach((e) => {
          e.classList.toggle('nnd-active-people')
        })
        setTimeout(() => {
          grid.classList.toggle('nnd-hide')
          Tracking.trackPageImpression(tabName, project.name)
        }, 200)
      }, 200)
    }
  }

  addVote (id, voteType) {
    
    // console.log('this.state.data.length', this.state.data.length)

    // if length is 50 means its the 100 to 51 list
    // let thisIndex = (this.state.data.length == 50) ? (id - 1 - 50) : (id - 1)
    let thisIndex = (id - 1)

    // console.log('id:', id)
    // console.log('thisIndex:', thisIndex)

    let isPeople = document.querySelector(`[name="nnd-people"]`)
    let whichClicked = document.querySelector(`.nnd-expert-` + id + ` .nnd-btns`)
    let isVoting = whichClicked.classList.contains('nnd-voting')
    // console.log('whichClicked',whichClicked)
    // console.log('isVoting',isVoting)
    // console.log('isPeople', isPeople)

    if (!this.state.data[thisIndex].status && !isPeople && !isVoting) {

      const data = {
        'method': 'higher_lower',
        'key': key,
        'id': id, // The ID the person is voting for
        'higher_lower': voteType, // one of higher, lower, agree
        'rampart_token': this.state.userToken,
      }

      whichClicked.classList.add('nnd-voting')
      // console.log('whichClicked', whichClicked)

      // Do the request
      axios.post(apiURL, data).then(response => {
        // console.log('POSTED', data, response)
        let pObj = this.state.data.find(obj => {
          return obj.id === id
        })

        // adjust for this vote for posted value
        if (voteType === 'lower') {
          pObj['perc']['underrated']++
        } else if (voteType === 'higher') {
          pObj['perc']['overrated']++
        } else if (voteType === 'agree') {
          pObj['perc']['agree']++
        }

        // console.log("pObj.perc", pObj.perc);
        
        let totalVotes = (pObj.perc.agree + pObj.perc.overrated + pObj.perc.underrated)
        let calUnderrated = Math.round((pObj.perc.underrated * 100) / totalVotes)
        let calOverrated = Math.round((pObj.perc.overrated * 100) / totalVotes)
        let calAgree = Math.round((pObj.perc.agree * 100) / totalVotes)
        if ((calUnderrated + calOverrated + calUnderrated) !== 100) {
          calAgree = (100 - calUnderrated - calOverrated)
        }

        this.state.data[thisIndex].status = voteType
        this.state.data[thisIndex].perc.underratedPC = (calUnderrated + '%')
        this.state.data[thisIndex].perc.overratedPC = (calOverrated + '%')
        this.state.data[thisIndex].perc.agreePC = (calAgree + '%')

        let selectElement = document.querySelector(`.nnd-expert-` + id + ` .nnd-btns`)
        let btns = selectElement.querySelectorAll('a')

        btns[0].querySelector('em').innerHTML = calOverrated + '%'
        btns[1].querySelector('em').innerHTML = calUnderrated + '%'
        btns[2].querySelector('em').innerHTML = calAgree + '%'

        if (voteType === 'higher') {
          btns[0].setAttribute('class', 'nnd-active')
        } else if (voteType === 'lower') {
          btns[1].setAttribute('class', 'nnd-active')
        } else if (voteType === 'agree') {
          btns[2].setAttribute('class', 'nnd-active')
        }

        // selectElement.classList.add('nnd-voted')
        whichClicked.classList.add('nnd-voted')
        whichClicked.classList.remove('nnd-voting') // voting finished

      })
      .catch(e => {

        whichClicked.classList.remove('nnd-voting')

        console.error(e.response.status)
          if (e.response.status === 403) {
          }
      })
      
    }
  }

  render() {
    const mylist = (typeof this.state.data !== 'undefined') ? this.state.data.map((item) => {
      // console.log('item.imagename', item)
      if (typeof this.state.data !== 'undefined') {
        return (
         <div key={item.id} className={`nnd-row nnd-expert-${item.id} nnd-people-${item.peopleid}`}>
           <div className="nnd-col-rating"><span className="nnd-rating-expert">{ item.id }</span><span className="nnd-rating-people">{ item.peopleid }</span></div>
           <div className="nnd-col-img">
             <picture>
               <source srcSet={require(`../assets/images/${item.imagename}_desktop.jpg`)} media="(min-width: 768px)" />
               <img srcSet={require(`../assets/images/${item.imagename}_mobile.jpg`)} src={require(`../assets/images/${item.imagename}_desktop.jpg`)} />
             </picture>
           </div>
           <div className="nnd-col-text">
             <h3>{ item.name }</h3>

             <p className="club"><span>Club:</span> { item.club }</p>
             
             <p className="salary"><span>SALARY:</span> { item.salary }</p>

             <p className="salary"><span>COVID SALARY:</span> { item.salaryCovid }</p>

             <p>{ item.desc }</p>

             <p className="nnd-expert-voteText">What do you think of his salary? Have your say below:</p>
             <p className="nnd-readers-voteText">{ item.name } is number { item.id } in the Official Top 100. This is what you thought:</p>

           </div>
           <div className="nnd-btns">
             <a onClick={(e) => { this.addVote(item.id, 'higher'); e.preventDefault() }}>Lucky boy<em>{ item.perc.overratedPC }%</em></a>
             <a onClick={(e) => { this.addVote(item.id, 'lower'); e.preventDefault() }}>Bargain<em>{ item.perc.underratedPC }%</em></a>
             <a onClick={(e) => { this.addVote(item.id, 'agree'); e.preventDefault() }}>Spot on<em>{ item.perc.agreePC }%</em></a>
           </div>
         </div>
        )
      }
    }) : ''

    const isUserToken = this.state.userToken;

    return (
      <div className="nnd-container">
        <div className="nnd-header">
          <img src={require('../assets/images/header.svg')} />
        </div>
        <div className="nnd-navigation-bg"></div>
        <div className="nnd-navigation">
            <div className="nnd-nav-btns">
              <a className="nnd-active-expert" onClick={(e) => { this.setClassName(e, 'expert'); e.preventDefault() }}>Official Top 100</a>
              <a onClick={(e) => { this.setClassName(e, 'people'); e.preventDefault() }}>Reader's Top 100</a>
            </div>
        </div>
        <div name="nnd-expert" className="nnd-cont-main">
          {mylist}
        </div>
      </div>
    )
  }
}

export default Home


// WEBPACK FOOTER //
// ./src/components/Home.js